export enum FurnishComponentType {
  Position = 0,
  Renderable = 2,
  Color = 3,
  Furniture = 4,
  Rotation = 10,
  Scale = 11,
  ZIndex = 12,
}
